<template>
  <div>
    <div>
      <el-form :disabled="!isOk" :inline="true" ref="form2">
        <el-form-item>
          <el-button type="primary" @click="handleAdd">新增</el-button>
          <el-button type="primary" @click="handleNext">Next</el-button>
<!--          <el-button type="primary" @click="handleExport">导出</el-button>-->
        </el-form-item>
      </el-form>
    </div>
    <div align="center">
      <div id="myChart" style="height: 600px"></div>
      <el-table :data="tableData" ref="dataTable" style="width: 100%">
        <el-table-column type="index" label="序号" width="50"/>
        <el-table-column prop="day" label="日期" width="150" show-overflow-tooltip/>
        <el-table-column prop="num" label="天数" width="100" show-overflow-tooltip/>
        <el-table-column label="操作" width="160" align="center">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-edit" @click="handleSet(scope.row)" size="small">修改</el-button>
            <el-button type="text" icon="el-icon-edit" @click="handleDel(scope.row)" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" width="500px">
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="日期" prop="day" :rules="[{required: true, message: '日期为空'}]">
            <el-date-picker v-model="form.day" type="date" value-format="yyyy-MM-dd" placeholder="购买日期" style="width: 280px"/>
          </el-form-item>
          <el-form-item label="天数" prop="num" type="number" :rules="[{required: true, message: '天数为空'}]">
            <el-input v-model="form.num" maxlength="50" style="width: 280px"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel('form')">取消</el-button>
          <el-button type="primary" v-if="dialogStatus==='add'" @click="add('form')"><span>确定</span></el-button>
          <el-button type="primary" v-if="dialogStatus==='set'" @click="set('form')"><span>确定</span></el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import * as http from '../api/http'
import * as util from '../util/util'
import global from '../components/Global'

let echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/line')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')

export default {
  name: 'Url',
  data () {
    return {
      isOk: false,
      dialogStatus: '',
      dialogTitle: '',
      dialogVisible: false,
      param: {},
      tableData: [],
      xdata: [],
      ydata: [],
      form: {}
    }
  },
  created () {
    let uid = global.uid
    let token = global.token
    // let uid = this.$cookies.get('uid0')
    // let token = this.$cookies.get('token0')
    if (uid === null || uid <= 0 || token === null || token === '') {
      this.$router.push('/')
      return
    }
    this.list()
  },
  methods: {
    drawLine () {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById('myChart'))

      // 绘制图表
      myChart.setOption({
        color: ['#3398DB'],
        title: {
          text: '月朗星稀'
        },
        tooltip: {},
        toolbox: {
          show: true,
          feature: {
            mark: {show: true},
            // dataView: {show: true, readOnly: false},
            magicType: {show: true, type: ['line', 'bar']},
            restore: {show: true},
            saveAsImage: {show: true}
          }
        },
        calculable: true,
        xAxis: {
          data: this.xdata
        },
        yAxis: {},
        series: [{
          name: '天数',
          type: 'line',
          data: this.ydata,
          markPoint: {
            data: [
              {type: 'max', name: '最大值'},
              {type: 'min', name: '最小值'}
            ]
          },
          markLine: {
            data: [
              {type: 'average', name: '平均值'}
            ]
          }
        }]
      })
    },
    cancel () {
      this.dialogVisible = false
    },
    add (formName) {
      const set = this.$refs
      set[formName].validate(valid => {
        this.form.uid = global.uid // this.$cookies.get('uid0')
        this.form.token = global.token // this.$cookies.get('token0')
        http.post(global.url0 + 'nsy-moon/add/', this.form).then(
          res => {
            if (res === 200) {
              this.dialogVisible = false
              this.$message.success('新增成功')
              this.list()
            } else {
              this.$message.error('新增失败:' + res)
            }
          }
        )
      })
    },
    set (formName) {
      const set = this.$refs
      set[formName].validate(valid => {
        this.form.uid = global.uid // this.$cookies.get('uid0')
        this.form.token = global.token // this.$cookies.get('token0')
        // console.log(this.form)
        http.post(global.url0 + 'nsy-moon/set/', this.form).then(
          res => {
            if (res === 200) {
              this.dialogVisible = false
              this.$message.success('修改成功')
              this.list()
            } else {
              this.$message.error('修改失败:' + res)
            }
          }
        )
      })
    },
    handleNext () {
      this.form = {}
      this.form.uid = global.uid // this.$cookies.get('uid0')
      this.form.token = global.token // this.$cookies.get('token0')
      http.post(global.url0 + 'moon/guess/', this.form).then(
        res => {
          this.$message.success(res)
        }
      )
    },
    handleAdd () {
      this.form = {}
      this.dialogStatus = 'add'
      this.dialogTitle = '新增'
      this.dialogVisible = true
    },
    handleSet (row) {
      this.form = JSON.parse(JSON.stringify(row))
      this.dialogStatus = 'set'
      this.dialogTitle = '修改'
      this.dialogVisible = true
    },
    handleDel (row) {
      this.$confirm('此操作将永久删除记录，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form = {}
        this.form.uid = global.uid // this.$cookies.get('uid0')
        this.form.token = global.token // this.$cookies.get('token0')
        this.form.id = row.id
        http.post(global.url0 + 'nsy-moon/del/', this.form).then(
          res => {
            if (res === 200) {
              this.$message.success('删除成功')
              this.list()
            } else {
              this.$message.error('删除失败')
            }
          }
        )
      })
    },
    list () {
      this.isOk = false
      this.tableData = []
      this.xdata = []
      this.ydata = []
      this.param.uid = global.uid // this.$cookies.get('uid0')
      this.param.token = global.token // this.$cookies.get('token0')

      http.post(global.url0 + 'nsy-moon/list/', this.param).then(
        res => {
          // console.log(res)
          let resStr = res.data.toString
          if (resStr.length > 0 && !String.startsWith(resStr, '[')) {
            this.$message.error(res)
            return
          }
          this.tableData = res.data

          for (let i = 0; i < this.tableData.length; i++) {
            this.xdata.push(this.tableData[i].day)
            this.ydata.push(this.tableData[i].num)
          }
          this.drawLine()

          this.isOk = true
        }
      )
    },
    handleExport () {
      util.toExcel(this.$refs.dataTable.columns, this.tableData, 'Url')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/views/Moon.vue